<template>
  <div class="auto-summary-page settings--content">
    <div class="auto-summary-settings-content">
      <div class="auto-summary-header">
        <img
          class="lia-avatar"
          src="~dashboard/assets/images/lia-avatar.png"
          alt="Lia"
        />
        <div class="auto-summary-header__text">
          <label class="auto-summary-header__title">
            {{ $t('INBOX_MGMT.AUTO_SUMMARY.ENABLE_LABEL') }}
          </label>
          <p class="auto-summary-header__description">
            {{ $t('INBOX_MGMT.AUTO_SUMMARY.ENABLE_DESCRIPTION') }}
          </p>
        </div>
        <WootSwitch v-model="autoSummaryEnabled" />
      </div>

      <label v-if="autoSummaryEnabled" class="settings-item">
        {{ $t('INBOX_MGMT.AUTO_SUMMARY.PROMPT.LABEL') }}
        <textarea
          v-model="prompt"
          class="auto-summary-prompt"
          rows="10"
          :placeholder="$t('INBOX_MGMT.AUTO_SUMMARY.PROMPT.PLACEHOLDER')"
        />
        <span v-if="showPromptError" class="message">
          {{ $t('INBOX_MGMT.AUTO_SUMMARY.PROMPT.ERROR') }}
        </span>
      </label>

      <woot-submit-button
        class="auto-summary-submit-button"
        :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
        :loading="uiFlags.isUpdating"
        @click="saveSettings"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import WootSwitch from 'components/ui/Switch';

export default {
  components: {
    WootSwitch,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      autoSummaryEnabled: false,
      prompt: '',
      showPromptError: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
    autoSummaryEnabled(enabled) {
      if (enabled && !this.prompt) {
        this.prompt = this.$t('INBOX_MGMT.AUTO_SUMMARY.PROMPT.DEFAULT');
      }
    },
    prompt() {
      this.showPromptError = false;
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.prompt = this.inbox.auto_summary_prompt || '';
      this.autoSummaryEnabled = this.inbox.auto_summary_enabled || false;
    },
    async saveSettings() {
      if (this.autoSummaryEnabled && !this.prompt.trim()) {
        this.showPromptError = true;
        return;
      }

      try {
        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.inbox.id,
          formData: false,
          auto_summary_enabled: this.autoSummaryEnabled,
          auto_summary_prompt: this.prompt,
        });
        this.showAlert(this.$t('INBOX_MGMT.AUTO_SUMMARY.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.AUTO_SUMMARY.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.auto-summary-settings-content {
  display: flex;
  flex-direction: column;
  outline: 1px var(--s-75) solid;
  outline-offset: -1px;
  border-radius: var(--border-radius-medium);
  padding: var(--space-normal);
}

.auto-summary-header {
  display: flex;
  align-items: center;
  gap: var(--space-normal);
  padding-bottom: var(--space-normal);

  .lia-avatar {
    width: var(--space-larger);
    height: var(--space-larger);
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }
}

.auto-summary-header__text {
  flex: 1;
}

.auto-summary-header__title {
  font-weight: var(--font-weight-bold);
}

.auto-summary-header__description {
  margin-bottom: 0;
}

.settings-item {
  padding-bottom: var(--space-normal);

  .message {
    color: var(--r-400);
    font-size: var(--font-size-mini);
  }
}

.auto-summary-prompt {
  margin-top: var(--space-small);
  margin-bottom: 0;
  resize: vertical;
}

.auto-summary-submit-button {
  align-self: start;
}
</style>
